import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "template" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("onSignIn")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("onSignOut")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("shareInfo")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Button, { onClick: _ctx.signin }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_Button, { onClick: _ctx.signout }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_Button, { onClick: _ctx.shareInfo }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}